import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css'; // Tailwind CSS - IMPORT FIRST
import './styles/font-fallbacks.css';
import './index.css';
import './config/i18n';
import { HelmetProvider } from './components/SEO/helmet';
import { Capacitor } from '@capacitor/core';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initNativeDevMode } from './utils/platformUtils';
import { installChunkErrorHandler } from './utils/chunkErrorHandler';
import { installPreSentryErrorBuffer } from './utils/preSentryErrorBuffer';
import { scheduleSentryInit } from './utils/initSentryDeferred';

initNativeDevMode();
installChunkErrorHandler();
installPreSentryErrorBuffer();

if (Capacitor.isNativePlatform()) {
  document.documentElement.dataset.appNative = 'true';
}

scheduleSentryInit();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <App />
  </HelmetProvider>
  // </React.StrictMode>
);

// UX native (status bar) — no-op sur le web. Splash masqué par NativeBootGate.
if (Capacitor.isNativePlatform()) {
  void import('./native/nativeAppInit').then((m) => m.initNativeUx());
}

reportWebVitals();
